
export const IS_BLOCKING_SETTINGS = 'IS_BLOCKING_SETTINGS';
export const PATH_NAME_SETTINGS = 'PATH_NAME_SETTINGS';


export const isBlockingSettings = (isBlockingSettings) => ({
    type: IS_BLOCKING_SETTINGS,
    payload: isBlockingSettings,
});
export const pathNameSettings = (pathnameSettings) => ({
    type: PATH_NAME_SETTINGS,
    payload: pathnameSettings,
});

